module.exports = __webpack_public_path__ + "static/media/errorWarning.79c5ab9c.svg";